//import api from '../api'
import { newAPIPost } from '../api/index.js';

export default {
  state: {
    doitem: [],
    searchRequest: {},
  },
  mutations: {
    updateDoitem(state, doitem) {
      state.doitem = doitem;
    },
    updateSearchDoitemRequest(state, searchRequest) {
      state.searchRequest = searchRequest;
    },
  },
  actions: {
    async loadDoitem({ commit, state }, request) {
      const fallbackRequest = request || state.searchRequest;
      const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));


    //   if (requestToSend.cutLFD.startDate)
    // {
    //     const date = moment(requestToSend.cutLFD.startDate)
    //                 .endOf('d')
    //                 .toDate();
    //     console.log(date)
    //     console.log(date.getMonth())
    //     console.log(date.getDate())
    //     var month = (date.getMonth() + 1).toString()
    //     if (month.length === 1)
    //     {
    //         month = '0' + month
    //     }
    //     var day = date.getDate().toString()
    //     if (day.length === 1)
    //     {
    //         day = '0' + day
    //     }

    //     requestToSend.cutLFD.startDate = date.getFullYear() + '-' + month + '-' + day
    // }

    // if (requestToSend.cutLFD.endDate)
    // { 
    //     const date = moment(requestToSend.cutLFD.endDate)
    //                 .endOf('d')
    //                 .toDate();

    //                 var month = (date.getMonth() + 1).toString()
    //                 if (month.length == 1)
    //                 {
    //                     month = '0' + month
    //                 }
            
    //                 var day = date.getDate().toString()
    //                 if (day.length == 1)
    //                 {
    //                     day = '0' + day
    //                 }
    //     requestToSend.cutLFD.endDate = date.getFullYear() + '-' + month + '-' + day
    // }
    // else
    // {
    //   if (requestToSend.cutLFD.startDate != null)
    //   {
    //     const date = moment(requestToSend.cutLFD.startDate)
    //                 .endOf('d')
    //                 .toDate();
    //     console.log(date)
    //     console.log(date.getMonth())
    //     console.log(date.getDate())
    //     var month = (date.getMonth() + 1).toString()
    //     if (month.length === 1)
    //     {
    //         month = '0' + month
    //     }

    //     var day = date.getDate().toString()
    //     if (day.length === 1)
    //     {
    //         day = '0' + day
    //     }

    //     requestToSend.cutLFD.endDate = date.getFullYear() + '-' + month + '-' + day
    //   }
        
    // }

    // requestToSend.cutLFD.startDate = "2000-01-01"
    // requestToSend.cutLFD.endDate = "2099-12-31"
     
    console.log(requestToSend);
      //const result = await api.post('/api/w/do/doitem', requestToSend);
      const result = await newAPIPost('/api/w/do/doitem', requestToSend);
      // const result = await api.post('/api/w/fsi/GetIBSOutbound', requestToSend);
      commit('updateSearchDoitemRequest', fallbackRequest);
      return commit('updateDoitem', result);
    },
    // saveDoitem({ dispatch }, request) {
    //   // return api.post('/api/w/do/doitem/action', request)
    // },
  },
  getters: {
    getDoitem: state => state.doitem,
  },
};
